import { render, staticRenderFns } from "./DiscountTaken.vue?vue&type=template&id=76d1fc1f"
import script from "./DiscountTaken.vue?vue&type=script&lang=js"
export * from "./DiscountTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d1fc1f')) {
      api.createRecord('76d1fc1f', component.options)
    } else {
      api.reload('76d1fc1f', component.options)
    }
    module.hot.accept("./DiscountTaken.vue?vue&type=template&id=76d1fc1f", function () {
      api.rerender('76d1fc1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subscription/unsubscription/DiscountTaken.vue"
export default component.exports